module.exports = "/assets/data/b8080cc89bda7f86159e9e850bcb988f-N6.data.json";